import { useAsyncEffect } from '@xylabs/sdk-react'
import { AuctionStatus } from '@xyo-network/sdk-xyoworld-js'
import { PropsWithChildren, useState } from 'react'

import { useMinter } from '../Minter'
import { AuctionCountContext } from './Context'

interface Props {
  enabled?: boolean
}

export const AuctionCountLoader: React.FC<PropsWithChildren<Props>> = (props) => {
  const { minter } = useMinter()
  const [countLoadCount, setCountLoadCount] = useState(0) //used to trigger effects

  const [liveAuctionCount, setLiveAuctionCount] = useState<number>()
  const [dutchAuctionCount, setDutchAuctionCount] = useState<number>()
  const [completedAuctionCount, setCompletedAuctionCount] = useState<number>()
  const [upcomingAuctionCount, setUpcomingAuctionCount] = useState<number>()
  const [mintedAuctionCount, setMintedAuctionCount] = useState<number>()

  const enabled = true

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      if (minter && enabled) {
        const liveAuctionCount = (await minter.listAuctions(AuctionStatus.Live))?.length
        if (!isMounted()) return
        setLiveAuctionCount(liveAuctionCount)
      }
    },
    [minter, countLoadCount, enabled],
  )

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      if (minter && enabled) {
        const dutchAuctionCount = (await minter.listAuctions(AuctionStatus.Dutch))?.length
        if (!isMounted()) return
        setDutchAuctionCount(dutchAuctionCount)
      }
    },
    [minter, countLoadCount, enabled],
  )

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      if (minter && enabled) {
        const completedAuctionCount = (await minter.listAuctions(AuctionStatus.Completed))?.length
        if (!isMounted()) return
        setCompletedAuctionCount(completedAuctionCount)
      }
    },
    [minter, countLoadCount, enabled],
  )

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      if (minter && enabled) {
        const upcomingAuctionCount = (await minter.listAuctions(AuctionStatus.Upcoming))?.length
        if (!isMounted()) return
        setUpcomingAuctionCount(upcomingAuctionCount)
      }
    },
    [minter, countLoadCount, enabled],
  )

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      if (minter && enabled) {
        const mintedAuctionCount = (await minter.listAuctions(AuctionStatus.Minted))?.length
        if (!isMounted()) return
        setMintedAuctionCount(mintedAuctionCount)
      }
    },
    [minter, countLoadCount, enabled],
  )

  const refreshAuctionCounts = () => {
    clearAuctionCounts()
    setCountLoadCount(countLoadCount + 1)
  }

  const clearAuctionCounts = () => {
    setLiveAuctionCount(undefined)
    setCompletedAuctionCount(undefined)
    setDutchAuctionCount(undefined)
    setMintedAuctionCount(undefined)
    setUpcomingAuctionCount(undefined)
  }

  return (
    <AuctionCountContext.Provider
      value={{
        availableAuctionCount: liveAuctionCount !== undefined && dutchAuctionCount !== undefined ? liveAuctionCount + dutchAuctionCount : undefined,
        busy:
          completedAuctionCount === null ||
          dutchAuctionCount === null ||
          liveAuctionCount === null ||
          mintedAuctionCount === null ||
          upcomingAuctionCount === null,
        clearAuctionCounts,
        completedAuctionCount,
        dutchAuctionCount,
        liveAuctionCount,
        mintedAuctionCount,
        refreshAuctionCounts,
        upcomingAuctionCount,
      }}
    >
      {props.children}
    </AuctionCountContext.Provider>
  )
}
